import { render, staticRenderFns } from "./CouponPubPaperPopup.vue?vue&type=template&id=7728f6ec&"
import script from "./CouponPubPaperPopup.vue?vue&type=script&lang=js&"
export * from "./CouponPubPaperPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports